import {Component, Input} from '@angular/core';

@Component({
  selector: 'gt-card-wrapper',
  templateUrl: './card-wrapper.component.html',
  styleUrls: ['./card-wrapper.component.scss']
})
export class CardWrapperComponent {
  @Input() cardTitle: string;
  @Input() matIcon: string;
}
